module.exports = __webpack_public_path__ + "static/img/corten-steel-wayfinding-signs.8087c88.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pages/view-our-work/corten-steel-wayfinding-signs.jpg
// module id = 439
// module chunks = 0